<template>
    <div v-if="isLoading" class="tw:fixed tw:inset-0 tw:z-[2000] tw:bg-[#ff091e1c]">
        <span class="tw:absolute tw:top-1/2 tw:left-1/2 tw:mt-[-25px] tw:ml-[-25px] tw:h-[50px] tw:w-[50px] tw:animate-loader-rotate
            tw:before:block tw:before:h-[20px] tw:before:w-[20px] tw:before:rounded-full tw:before:content-['']
            tw:before:mb-[10px] tw:before:bg-white tw:before:[box-shadow:30px_0_0_var(--tw-color-primary)] tw:before:animate-loader-ball1
            tw:after:block tw:after:h-[20px] tw:after:w-[20px] tw:after:rounded-full tw:after:content-['']
            tw:after:bg-primary tw:after:[box-shadow:30px_0_0_#fff] tw:after:animate-loader-ball2"></span>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: "LoadingPage",
    computed: {
        ...mapState(['isLoading'])
    },
}
</script>
